// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore"; // Importa Firestore
import { getStorage } from "firebase/storage"; // Importa Storage
import { getAuth } from "firebase/auth"; // Importa Auth

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAOvL88SNBkDkFuWp2CgDxg2EDT9BAWdmk",
  authDomain: "my-store-syl.firebaseapp.com",
  projectId: "my-store-syl",
  storageBucket: "my-store-syl.appspot.com",
  messagingSenderId: "448497083847",
  appId: "1:448497083847:web:e97619caf05a1349cce5e2",
  measurementId: "G-EP7YJQ3E8P"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
const db = getFirestore(app);

// Initialize Storage
const storage = getStorage(app); // Instancia de Storage

// Initialize Auth
const auth = getAuth(app); // Instancia de Auth

export { db, storage, auth };

